import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import LoadingWrapper from '../../layout/components/LoadingWrapper';
import FeatureCompatibilityMatrix from './FeatureCompatibilityMatrix';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FeatureCompatibilityModal({
  appContext,
  featuresWithTierCompatibility,
  offeringType,
  onClose,
  portalTiers,
  requestState,
  tierGroupNames,
  trackInteraction
}) {
  return /*#__PURE__*/_jsxs(Modal, {
    width: "90%",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        color: "fill-positive-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-common.compatibility.featureCompatibilityModal.header"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      padding: "0",
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatus: requestState,
        children: /*#__PURE__*/_jsx(FeatureCompatibilityMatrix, {
          featuresWithTierCompatibility: featuresWithTierCompatibility,
          featureType: unescapedText(`marketplace-ui-common.compatibility.offeringType.${offeringType}`),
          isCustomer: appContext === 'app',
          portalTiers: portalTiers,
          tierGroupNames: tierGroupNames,
          trackPricingLinkClick: tierGroup => trackInteraction('click compatibility modal pricing link', {
            section: 'overview',
            value: tierGroup
          })
        })
      })
    })]
  });
}